// extracted by mini-css-extract-plugin
var _1 = "SetProgressTest__mainTwoRows--qEtv0";
var _2 = "SetProgressTest__row--DlmfM";
var _3 = "SetProgressTest__secondRow--pWXGv SetProgressTest__row--DlmfM";
export { _1 as "mainTwoRows", _2 as "row", _3 as "secondRow" }
